"use client";

import { cn } from "@/lib/utils";
import { useLegendItem } from "./legend-context";

export interface LegendIndexProps {
  className?: string;
}

export function LegendIndex({
  className = "text-xs text-legend-muted-foreground tabular-nums",
}: LegendIndexProps) {
  const { index } = useLegendItem();
  return <div className={cn(className)}>{index + 1}</div>;
}

LegendIndex.displayName = "LegendIndex";
